import script from "./ChatSettingView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSettingView.vue?vue&type=script&setup=true&lang=js"

import "./ChatSettingView.vue?vue&type=style&index=0&id=5b66acbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b66acbc"]])

export default __exports__